import { ValidatorFn, AbstractControl } from '@angular/forms';

export function repeatPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const invalid = control.value !== control.parent?.controls['password'].value;
    return invalid ? { passwordDifferent: invalid} : null;
  };
}
